export const qrMode = {
  QR_SESAMEKEY: 'sk',
  QR_FRIEND: 'friend',
  QR_MATTER: 'matter',
};
